<template>
  <div id="history" ref="elememt">
    <div class="box">
      <div class="title">
        <el-row>
          <el-col :span="12">
            <div class="lv2Text">我的足迹</div>
          </el-col>
          <el-col :span="12">
            <div class="lv3Text clear" align="right" @click="clearAll">
              <i class="fas fa-trash-alt"></i>清空足迹
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="padding-top:40px" class="line">
        <el-row :gutter="20" v-if="data">
          <el-col :span="6" v-for="item in data" :key="item.id">
            <div class="item" @mouseleave="hoverId=0">
              <div class="del" style="float:right" @click="del(item.views_id)">
                <i style="font-size:16px" class="el-icon-close"></i>
              </div>
              <router-link :to="'/view?id='+item.product_id">
                <div
                  v-if="item.images!=null"
                  class="cover"
                  :style="'backgroundImage:url(' + serve +item.images.split(';')[0]+')'"
                ></div>
              </router-link>
              <div class="title lv2Text" v-if="item.title!=null">
                <router-link :to="'/product/'+item.product_id">{{item.title.substr(0,10)}}</router-link>
              </div>
              <div class="lv0Text price">&yen;{{item.selling_price}}</div>
            </div>
          </el-col>
        </el-row>
        <div v-if="loading" style="padding:30px 0;">
          <square-loader color="#e2211c"></square-loader>
        </div>
        <div class="lv4Text" style="text-align:center;padding-bottom:50px" v-if="empty">没有足迹记录</div>
      </div>

      <div style="padding:0 100px;margin-top:60px;" v-if="!more">
        <el-divider content-position="center">
          <span class="lv4Text">到底线了</span>
        </el-divider>
      </div>
    </div>
  </div>
</template>

<script>
import SquareLoader from "vue-spinner/src/SquareLoader.vue";

export default {
  components: {
    SquareLoader
  },
  data() {
    return {
      serve: this.$store.state.serve,

      data: null,
      page: 1,
      loading: false,
      hoverId: 0,
      empty: false,
      loading: true,
      more: true
    };
  },
  activated() {
    this.$store.state.user_location = "我的足迹";
  },
  created() {
    this.initData();
    var that = this;
    window.onscroll = function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      var h1 = scrollHeight - 600;
      var h2 = scrollTop + windowHeight;
      if (scrollHeight - scrollTop - windowHeight < 600) {
        that.appendData();
      }
    };
  },
  watch: {
    $route: {
      handler(route) {
        const that = this;
        if (route.name === "history/1") {
          that.initData();
        }
      },
      deep: true
    }
  },
  methods: {
    alert_success(message) {
      this.$message({
        message: message,
        type: "success",
        offset: 200
      });
    },
    alert_error(message) {
      this.$message({
        message: message,
        type: "error",
        offset: 200
      });
    },
    del(id) {
      var where = {
        mobile: this.$cookies.get("user"),
        token: this.$cookies.get("token"),
        ids: id
      };
      this.axios
        .get(this.serve + "/personal/del_views", {
          params: where
        })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.alert_success("足迹已删除");
            if (this.page > 1) {
              this.page = this.page - 1;
            }
            this.initData();
          } else {
            this.alert_error("足迹删除失败");
            if (this.page > 1) {
              this.page = this.page - 1;
            }
            this.initData();
          }
        });
    },
    clearAll() {
      this.axios
        .get(this.serve + "/personal/clear_views", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message("足迹已清空");
            this.data = null;
          }
        });
    },
    appendData() {
      if (this.more) {
        this.page++;
        this.loading = true;
        var page = this.page;
        this.axios
          .get(this.serve + "/personal/views_list", {
            params: {
              mobile: this.$cookies.get("user"),
              token: this.$cookies.get("token"),
              page: page
            }
          })
          .then(res => {
            this.loading = false;
            if (res.data.data) {
              let data = res.data.data.results;
              for (var item of data) {
                this.data.push(item);
              }
            } else {
              this.more = false;
            }
          });
      }
    },
    initData() {
      var page = this.page;
      this.axios
        .get(this.serve + "/personal/views_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: page ? page : 1
          }
        })
        .then(res => {
          this.loading = false;
          if (res.data.data) {
            this.data = res.data.data.results;
          } else {
            this.empty = true;
            this.more = false;
            this.data = [];
          }
        });
    }
  }
};
</script>
<style lang="scss">
#history {
  background-color: #fff;
  min-height: 975px;
  border: 1px solid #ddd;
  .box {
    .del {
      transition: all 0.3s;
      opacity: 0;
      position: absolute;
      top: 3px;
      right: 3px;
      cursor: pointer;
    }
    .del:hover {
      color: #e2211c;
    }
    .line {
      .fa-trash-alt {
        margin: 10px;
        margin-bottom: -16px;
        cursor: pointer;
        float: right;
      }
      .fa-trash-alt:hover {
        color: #e2211c;
      }
    }
    .el-icon-loading {
      font-size: 50px;
    }
    .item:hover .del {
      opacity: 1;
      transition: all 0.3s;
    }
    .item {
      border: 1px solid #ddd;
      text-align: center;
      margin-bottom: 20px;
      position: relative;
      .title {
        margin: 10px 0 5px 0;
      }
      .title:hover {
        text-decoration: underline;
      }
      .price {
        margin: 10px 0 5px 0;
      }
    }
    .cover {
      height: 174px;
      width: 174px;
      margin: 10px auto;
      background-position: center center;
      background-size: 100% auto;
      cursor: auto;
      background-repeat: no-repeat;
    }
    .clear {
      cursor: pointer;
    }
    .clear:hover {
      color: #606266;
    }
    background-color: #fff;
    padding: 20px;
    .fa-trash-alt {
      margin-right: 5px;
    }
  }
}
</style>